<template>
  <div class="flex w-full h-full mx-auto p-6">
    <div
      class="bg-white shadow-lg rounded-lg w-2/6 mx-4 pt-4 pb-32 px-4 overflow-hidden"
    >
      <div class="flex items-center pb-4">
        <h3
          class="font-bold text-gray-900 px-5 py-3 leading-tight tracking-wider"
        >
          Lista de configuraciones
        </h3>
      </div>
      <input
        type="text"
        v-model="search"
        placeholder="Búsqueda de configuraciones"
        class="w-full appearance-none border rounded py-2 px-3 text-gray-900 bg-gray-200 focus:outline-none focus:bg-white focus:border-teal-500"
      />
      <div class="h-full overflow-auto">
        <div
          v-for="config in filteredEvents"
          :key="config.name"
          class="group flex items-center cursor-pointer my-1 hover:bg-gray-300 py-2 px-5 text-left"
          :class="{ 'bg-secondary-color': config.name === currentConfig.name }"
          @click="selectEvent(config)"
        >
          <svg
            v-if="config.name === 'Encuestas'"
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              config.name === currentConfig.name
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-6 w-6 fill-current group-hover:text-gray-900"
            viewBox="0 0 24 24"
          >
            <path
              d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
          <svg
            v-if="config.name === 'Autoridades'"
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              config.name === currentConfig.name
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-6 w-6 fill-current group-hover:text-gray-900"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
          <svg
            v-if="config.name === 'Lugares de interés'"
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              config.name === currentConfig.name
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-6 w-6 fill-current group-hover:text-gray-900"
            viewBox="0 0 24 24"
          >
            <path
              d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
          <svg
            v-if="config.name === 'Eventos'"
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              config.name === currentConfig.name
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-6 w-6 fill-current group-hover:text-gray-900"
            viewBox="0 0 24 24"
          >
            <path
              d="M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
            />
            <path d="M0 0h24v24H0z" fill="none" />
          </svg>
          <svg
            v-if="config.name === 'Denuncias'"
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              config.name === currentConfig.name
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-6 w-6 fill-current group-hover:text-gray-900"
            viewBox="0 0 24 24"
          >
            <path
              d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            />
          </svg>

          <svg
            v-if="config.name === 'Enlaces Externos'"
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              config.name === currentConfig.name
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-6 w-6 fill-current group-hover:text-gray-900"
            viewBox="0 0 24 24"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
            />
          </svg>

          <svg
            v-if="config.name === 'Números de emergencia'"
            xmlns="http://www.w3.org/2000/svg"
            :class="[
              config.name === currentConfig.name
                ? 'text-gray-100'
                : 'text-gray-900',
            ]"
            class="h-6 w-6 fill-current group-hover:text-gray-900"
            viewBox="0 0 24 24"
          >
            <path d="M0 0h24v24H0z" fill="none" />
            <path
              d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
            />
          </svg>

          <div class="flex flex-col ml-2">
            <span
              :class="[
                config.name === currentConfig.name
                  ? 'text-gray-100'
                  : 'text-gray-900',
              ]"
              class="group-hover:text-gray-900"
              >{{ config.name }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="currentConfig.name === 'Encuestas'"
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg"
            >Categorías de encuestas</span
          >
          <div class="flex-1 text-right">
            <button
              v-on:click="newFormCategoryModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Crear Categoría
            </button>
          </div>
        </div>

        <div class="w-5/6 mx-auto">
          <div class="bg-white shadow-md rounded my-6">
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Categorías
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="category in formCategories">
                  <tr class="hover:bg-gray-200" :key="category.id">
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ category.category_name }}
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a
                        v-on:click="openFormCategoryModal(category)"
                        class="text-white cursor-pointer font-bold py-1 px-3 rounded text-xs bg-secondary-color hover:bg-secondary-color-dark"
                        >Editar</a
                      >
                      <!-- <a
                        v-if="!category.enabled"
                        v-on:click="updateFormCategory(category)"
                        class="text-gray-100 cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-green-500 hover:bg-green-700"
                      >Activar</a>-->
                      <a
                        @click="
                          showingConfirmPolls = true;
                          deleteCategoryPolls = category;
                        "
                        class="text-white cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-danger-color"
                        >Eliminar</a
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <form-category-modal
        :newFormCategory="newFormCategory"
        :showing="showFormCategoryModal"
        @updateFormCategoryModal="fetchFormCategories"
        @updateAllFormCategories="fetchFormCategories"
        @close="showFormCategoryModal = false"
      ></form-category-modal>
    </div>

    <div
      v-if="currentConfig.name === 'Autoridades'"
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg"
            >Tipos de autoridad</span
          >
          <div class="flex-1 text-right">
            <button
              v-on:click="newAuthotityTypeModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Crear Categoría
            </button>
          </div>
        </div>

        <div class="w-5/6 mx-auto">
          <div class="bg-white shadow-md rounded my-6">
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Categorías
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Área
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="type in authorityTypes">
                  <tr class="hover:bg-gray-200" :key="type.id">
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ type.name_category }}
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ type.area }}
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a
                        v-on:click="openAuthotityTypeModal(type)"
                        class="text-white cursor-pointer font-bold py-1 px-3 rounded text-xs bg-secondary-color hover:bg-secondary-color-dark"
                        >Editar</a
                      >
                      <!-- <a
                        v-if="!type.enabled"
                        v-on:click="updateActivity(type)"
                        class="text-gray-100 cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-green-500 hover:bg-green-700"
                      >Activar</a>-->
                      <a
                        @click="
                          showingConfirmAutorities = true;
                          deleteCategoryAuthorities = type;
                        "
                        class="text-white cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-danger-color"
                        >Eliminar</a
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <authorityType-modal
        :newAuthorityType="newAuthorityType"
        :showing="showAuthorityTypeModal"
        @updateAuthotityTypeModal="updateAuthotityTypeModal"
        @updateAllAuthorityTypes="updateAllAuthorityTypes"
        @close="showAuthorityTypeModal = false"
      ></authorityType-modal>
    </div>

    <div
      v-if="currentConfig.name === 'Lugares de interés'"
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg"
            >Categorías de lugares de interés</span
          >
          <div class="flex-1 text-right">
            <button
              v-on:click="newPlaceCategoryModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Crear Categoría
            </button>
          </div>
        </div>

        <div class="w-5/6 mx-auto">
          <div class="bg-white shadow-md rounded my-6">
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Categorías
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="category in placeCategories">
                  <tr class="hover:bg-gray-200" :key="category.id">
                    <td class="py-4 px-6 border-b border-gray-300">
                      <div class="flex items-center">
                        <img 
                        v-if="category.icon !== 'null'"
                        :src="srcUrl+'/img/places_icons/'+category.icon"
                        class="h-6 w-6"
                        />
                        <img v-else :src="srcUrl + '/' + category.url_image" class="h-6 w-6" />
                        <span class="pl-4">{{ category.nombre_categoria }}</span>
                      </div>
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a
                        v-on:click="openPlaceCategoryModal(category)"
                        class="text-white cursor-pointer font-bold py-1 px-3 rounded text-xs bg-secondary-color hover:bg-secondary-color-dark"
                        >Editar</a
                      >
                      <!-- <a
                        v-if="!category.enabled"
                        v-on:click="updatePlaceCategory(category)"
                        class="text-gray-100 cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-green-500 hover:bg-green-700"
                      >Activar</a>-->
                      <a
                        @click="
                          showingConfirmPlaces = true;
                          deleteCategoryPlaces = category;
                        "
                        class="text-white cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-danger-color"
                        >Eliminar</a
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <place-category-modal
        :newPlaceCategory="newPlaceCategory"
        :showing="showPlaceCategoryModal"
        @updatePlaceCategoryModal="fetchPlaceCategories"
        @updateAllPlaceCategories="fetchPlaceCategories"
        @close="showPlaceCategoryModal = false"
      ></place-category-modal>
    </div>

    <div
      v-if="currentConfig.name === 'Eventos'"
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg"
            >Categorías de Eventos</span
          >
          <div class="flex-1 text-right">
            <button
              v-on:click="newEventCategoryModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Crear Categoría
            </button>
          </div>
        </div>

        <div class="w-5/6 mx-auto">
          <div class="bg-white shadow-md rounded my-6">
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Categorías
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="category in eventCategories">
                  <tr class="hover:bg-gray-200" :key="category.id">
                    <td class="py-4 px-6 border-b border-gray-300">
                      <div class="flex items-center">
                        <img :src="srcUrl + '/' + category.url_image" class="h-6 w-6" />
                        <span class="pl-4">{{ category.name }}</span>
                      </div>
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a
                        v-on:click="openEventCategoryModal(category)"
                        class="text-white cursor-pointer font-bold py-1 px-3 rounded text-xs bg-secondary-color hover:bg-secondary-color-dark"
                        >Editar</a
                      >
                      <!-- <a
                        v-if="!category.enabled"
                        v-on:click="updateEventCategory(category)"
                        class="text-gray-100 cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-green-500 hover:bg-green-700"
                      >Activar</a>-->
                      <a
                        @click="
                          showingConfirmEvents = true;
                          deleteCategoryEvents = category;
                        "
                        class="text-white cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-danger-color"
                        >Eliminar</a
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <event-category-modal
        :newEventCategory="newEventCategory"
        :showing="showEventCategoryModal"
        @updateEventCategoryModal="fetchEventCategories"
        @updateAllEventCategories="fetchEventCategories"
        @close="showEventCategoryModal = false"
      ></event-category-modal>
    </div>

    <div
      v-if="currentConfig.name === 'Denuncias'"
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg"
            >Categorías de denuncias</span
          >
          <div class="flex-1 text-right">
            <button
              v-on:click="newComplaintCategoryModal()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Crear Categoría
            </button>
          </div>
        </div>

        <div class="w-5/6 mx-auto">
          <div class="bg-white shadow-md rounded my-6">
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Categorías
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Correo
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="type in complaintCategories">
                  <tr class="hover:bg-gray-200" :key="type.id">
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ type.name }}
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ type.email | sliceString }}
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a
                        v-on:click="openComplaintCategoryModal(type)"
                        class="text-white cursor-pointer font-bold py-1 px-3 rounded text-xs bg-secondary-color hover:bg-secondary-color-dark"
                        >Editar</a
                      >
                      <!-- <a
                        v-if="!type.enabled"
                        v-on:click="updateComplaintCategory(type)"
                        class="text-gray-100 cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-green-500 hover:bg-green-700"
                      >Activar</a>-->
                      <a
                        @click="
                          showingConfirmComplaints = true;
                          deleteCategoryComplaints = type;
                        "
                        class="text-white cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-danger-color"
                        >Eliminar</a
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <complaintCategory-modal
        :newComplaintCategory="newComplaintCategory"
        :showing="showComplaintCategoryModal"
        @updateComplaintCategoryModal="updateComplaintCategoryModal"
        @updateAllComplaintCategories="updateAllComplaintCategories"
        @close="showComplaintCategoryModal = false"
      ></complaintCategory-modal>
    </div>

    <div
      v-if="currentConfig.name === 'Enlaces Externos'"
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg">Enlaces externos</span>
          <div class="flex-1 text-right">
            <button
              v-on:click="newLink()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Crear un enlace
            </button>
          </div>
        </div>

        <div class="w-5/6 mx-auto">
          <div class="bg-white shadow-md rounded my-6">
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Nombre
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    url
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="category in externalLinks">
                  <tr class="hover:bg-gray-200" :key="category.id">
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ category.name }}
                    </td>
                    <!-- <td class="py-4 px-6 border-b border-gray-300">{{category.url}}</td> -->
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a :href="category.url" target="_blank">{{
                        category.url
                      }}</a>
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a
                        v-on:click="openLinkModal(category)"
                        class="text-white cursor-pointer font-bold py-1 px-3 rounded text-xs bg-secondary-color hover:bg-secondary-color-dark"
                        >Editar</a
                      >
                      <a
                        @click="
                          showingConfirmLinks = true;
                          deleteCategoryLinks = category;
                        "
                        class="text-white cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-danger-color"
                        >Eliminar</a
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <external-link-modal
        :newExternalLink="newLinkModal"
        :showing="showLinkModal"
        @updateExternalLinkModal="fetchLinks"
        @updateAllExternalLinks="fetchLinks"
        @close="showLinkModal = false"
      ></external-link-modal>
    </div>

    <div
      v-if="currentConfig.name === 'Números de emergencia'"
      class="flex flex-wrap bg-white shadow-lg rounded-lg w-4/6 mx-4 py-8 overflow-hidden"
    >
      <div class="w-full px-4 py-2 h-full overflow-auto">
        <div class="w-full flex flex-wrap items-center px-20">
          <span class="font-bold text-gray-900 text-lg"
            >Números de emergencia</span
          >
          <div class="flex-1 text-right">
            <button
              v-on:click="newEmergencyNumber()"
              class="bg-transparent hover:bg-secondary-color text-secondary-color-dark font-semibold hover:text-white py-2 px-4 mx-1 border border-secondary-color-dark hover:border-transparent rounded"
            >
              Crear número de emergencia
            </button>
          </div>
        </div>

        <div class="w-5/6 mx-auto">
          <div class="bg-white shadow-md rounded my-6">
            <table class="text-left w-full border-collapse">
              <thead>
                <tr>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Nombre
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Número
                  </th>
                  <th
                    class="py-4 px-6 bg-gray-100 font-bold uppercase text-sm text-gray-900 border-b border-gray-300"
                  >
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="category in emergencyNumbers">
                  <tr class="hover:bg-gray-200" :key="category.id">
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ category.nombre }}
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      {{ category.numero }}
                    </td>
                    <td class="py-4 px-6 border-b border-gray-300">
                      <a
                        v-on:click="openEmergencyNumberModal(category)"
                        class="text-white cursor-pointer font-bold py-1 px-3 rounded text-xs bg-secondary-color hover:bg-secondary-color-dark"
                        >Editar</a
                      >
                      <a
                        @click="
                          showingConfirmEmergencyNumbers = true;
                          deleteCategoryEmergencyNumbers = category;
                        "
                        class="text-white cursor-pointer font-bold py-1 px-3 ml-2 rounded text-xs bg-red-500 hover:bg-danger-color"
                        >Eliminar</a
                      >
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <emergency-number-modal
        :newEmergencyNumber="newEmergencyNumberModal"
        :showing="showEmergencyNumberModal"
        @updateEmergencyNumberModal="fetchEmergencyNumbers"
        @updateAllEmergencyNumbers="fetchEmergencyNumbers"
        @close="showEmergencyNumberModal = false"
      ></emergency-number-modal>
      <!-- <external-link-modal
        :newExternalLink="newLinkModal"
        :showing="showLinkModal"
        @updateExternalLinkModal="fetchLinks"
        @updateAllExternalLinks="fetchLinks"
        @close="showLinkModal = false"
      ></external-link-modal> -->
    </div>

    <alert-dialog :showing="showingConfirmPolls">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar esta categoría de encuestas?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateFormCategory(deleteCategoryPolls)"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmPolls = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmAutorities">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar esta categoría de autoridad?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateActivity(deleteCategoryAuthorities)"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmAutorities = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmPlaces">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar esta categoría de lugares de interes?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updatePlaceCategory(deleteCategoryPlaces)"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmPlaces = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmEvents">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar esta categoría de eventos?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateEventCategory(deleteCategoryEvents)"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmEvents = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmComplaints">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar esta categoría de Denuncias?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateComplaintCategory(deleteCategoryComplaints)"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmComplaints = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmLinks">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar este enlace externo?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateLinks(deleteCategoryLinks)"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmLinks = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingConfirmEmergencyNumbers">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">
          ¿Desea eliminar este número de emergencia?
        </div>
      </div>
      <div class="w-full flex items-center justify-center">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-red-500 border-4 font-bold tracking-wider bg-white hover:bg-red-300"
          @click="updateEmergencyNumbers(deleteCategoryEmergencyNumbers)"
        >
          Eliminar
        </button>
        <button
          class="mt-4 px-4 py-2 ml-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingConfirmEmergencyNumbers = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>

    <alert-dialog :showing="showingSuccessDelete">
      <div class="flex items-center justify-center">
        <div class="uppercase text-gray-900">Eliminado exitosamente</div>
        <div class="ml-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-8 lg:w-12 h-8 lg:h-12 fill-current text-primary-color"
            viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0z" />
            <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
          </svg>
        </div>
      </div>
      <div class="w-full">
        <button
          class="mt-4 px-4 py-2 rounded-lg text-gray-900 border-gray-500 border-4 font-bold tracking-wider bg-white hover:bg-gray-300"
          @click="showingSuccessDelete = false"
        >
          Cerrar
        </button>
      </div>
    </alert-dialog>
  </div>
</template>

<script>
import authorityTypeModal from "./AuthorityTypeModal";
import complaintCategoryModal from "./ComplaintCategoryModal";
import FormCategoryModal from "./FormCategoryModal";
import PlaceCategoryModal from "./PlaceCategoryModal";
import EventCategoryModal from "./EventCategoryModal";
import ExternalLinkModal from "./ExternalLinkModal";
import EmergencyNumberModal from "./EmergencyNumberModal";
import AlertDialog from "./AlertDialog";
import EventBus from "../event-bus";

export default {
  name: "config-list",
  data() {
    return {
      showingConfirmPolls: false,
      showingConfirmAutorities: false,
      showingConfirmPlaces: false,
      showingConfirmEvents: false,
      showingConfirmComplaints: false,
      showingConfirmLinks: false,
      showingConfirmEmergencyNumbers: false,
      showingSuccessDelete: false,

      deleteCategoryPolls: null,
      deleteCategoryAuthorities: null,
      deleteCategoryPlaces: null,
      deleteCategoryEvents: null,
      deleteCategoryComplaints: null,
      deleteCategoryLinks: null,
      deleteCategoryEmergencyNumbers: null,
      configs: [
        { name: "Encuestas" },
        { name: "Autoridades" },
        { name: "Lugares de interés" },
        { name: "Eventos" },
        { name: "Denuncias" },
        { name: "Enlaces Externos" },
        { name: "Números de emergencia" },
      ],
      search: "",
      currentConfig: {},
      authorityTypes: [],
      complaintCategories: [],
      newAuthorityType: false,
      newComplaintCategory: false,
      showAuthorityTypeModal: false,
      showComplaintCategoryModal: false,
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      formCategories: [],
      newFormCategory: false,
      showFormCategoryModal: false,
      placeCategories: [],
      eventCategories: [],
      externalLinks: [],
      emergencyNumbers: [],
      newPlaceCategory: false,
      showPlaceCategoryModal: false,
      newEventCategory: false,
      showEventCategoryModal: false,
      newLinkModal: false,
      showLinkModal: false,
      newEmergencyNumberModal: false,
      showEmergencyNumberModal: false,
      srcUrl: 'apidev'
    };
  },
  components: {
    authorityTypeModal,
    complaintCategoryModal,
    AlertDialog,
    FormCategoryModal,
    PlaceCategoryModal,
    EventCategoryModal,
    ExternalLinkModal,
    EmergencyNumberModal,
  },
  mounted() {
    this.fetchFormCategories();
    this.fetchComplaintCategories();
    this.fetchAuthorityTypes();
    this.fetchPlaceCategories();
    this.fetchEventCategories();
    this.fetchLinks();
    this.fetchEmergencyNumbers();
    this.currentConfig = this.configs[0];
  },
  methods: {
    //********* Autoridades ************
    fetchAuthorityTypes() {
      //this.currentConfig = this.configs[1];
      this.axios
        .get("apidev/authorities/categories/listAll", this.config)
        .then((response) => {
          this.authorityTypes = response.data.categories;
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    selectEvent(config) {
      this.currentConfig = config;
    },

    openAuthotityTypeModal: function (authorityType) {
      this.showAuthorityTypeModal = true;
      this.newAuthorityType = false;
      EventBus.$emit("editModal", authorityType);
    },

    updateAuthotityTypeModal: function (authorityType) {
      this.authorityTypes.forEach((type) => {
        if (type.id == authorityType.id) {
          let updateAuthority = Object.assign({}, authorityType);
          type.name_category = updateAuthority.name_category;
          type.area = updateAuthority.area;
        }
      });
    },

    newAuthotityTypeModal: function () {
      this.showAuthorityTypeModal = true;
      this.newAuthorityType = true;
    },

    updateAllAuthorityTypes: function () {
      this.fetchAuthorityTypes();
    },

    updateActivity: function (authorityType) {
      this.axios
        .delete(
          "apidev/authorities/categories/" + authorityType.id,
          // {
          //   name_category: authorityType.name_category,
          //   enabled: !authorityType.enabled,
          //   id: authorityType.id
          // },
          this.config
        )
        .then((response) => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Configuración",
              action: "Eliminación de una categoría de autoridad",
              observation: authorityType.name_category,
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          //authorityType.enabled = !authorityType.enabled;
          this.showingConfirmAutorities = false;
          this.showingSuccessDelete = true;
          this.fetchAuthorityTypes();
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          console.error(error.response);
        });
    },

    //********* Denuncias ************

    fetchComplaintCategories() {
      //this.currentConfig = this.configs[4];
      this.axios
        .post("apidev/visitors/complaintCategories", {}, this.config)
        .then((response) => {
          this.complaintCategories = response.data.categories;
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

    updateComplaintCategory: function (categoryType) {
      this.axios
        .delete(
          "apidev/visitors/complaint/categories/" + categoryType.id,
          // {
          //   name: categoryType.name,
          //   enabled: !categoryType.enabled,
          //   email: categoryType.email,
          //   id: categoryType.id
          // },
          this.config
        )
        .then((response) => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Configuración",
              action: "Eliminación de una categoría de denuncia",
              observation: categoryType.name,
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          //categoryType.enabled = !categoryType.enabled;
          this.showingConfirmComplaints = false;
          this.showingSuccessDelete = true;
          this.fetchComplaintCategories();
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },

    newComplaintCategoryModal: function () {
      this.showComplaintCategoryModal = true;
      this.newComplaintCategory = true;
      EventBus.$emit("newModal");
    },

    updateAllComplaintCategories: function () {
      this.fetchComplaintCategories();
    },

    updateComplaintCategoryModal: function (complaintCategory) {
      this.complaintCategories.forEach((type) => {
        if (type.id == complaintCategory.id) {
          let updateComplaint = Object.assign({}, complaintCategory);
          type.name = updateComplaint.name;
          type.email = updateComplaint.email;
        }
      });
    },

    openComplaintCategoryModal: function (complaintCategory) {
      this.showComplaintCategoryModal = true;
      this.newComplaintCategory = false;
      EventBus.$emit("editModal", complaintCategory);
    },

    //***************************************
    fetchFormCategories() {
      this.axios
        .get("apidev/api/polls/categories/listAll", this.config)
        .then((response) => {
          this.formCategories = response.data;
        })
        .catch((error) => {
          console.log(error);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    newFormCategoryModal() {
      this.showFormCategoryModal = true;
      this.newFormCategory = true;
    },
    openFormCategoryModal(category) {
      this.showFormCategoryModal = true;
      this.newFormCategory = false;
      EventBus.$emit("editModal", category);
    },
    updateFormCategory(category) {
      this.axios
        .delete(
          "apidev/api/polls/categories/" + category.id,
          // {
          //   name: category.category_name,
          //   enabled: !category.enabled
          // },
          this.config
        )
        .then((response) => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Configuración",
              action: "Eliminación de una categoría de encuestas",
              observation: category.category_name,
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          //category.enabled = !category.enabled;
          this.showingConfirmPolls = false;
          this.showingSuccessDelete = true;
          this.fetchFormCategories();
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchPlaceCategories() {
      this.axios
        .get("apidev/api/places/category", this.config)
        .then((response) => {
          this.placeCategories = response.data;
        });
    },
    fetchEventCategories() {
      this.axios
        .get("apidev/api/config/categories/events", this.config)
        .then((response) => {
          this.eventCategories = response.data.categories;
        })
        .catch((error) => {
          console.error(error.response);
        });
    },
    newPlaceCategoryModal() {
      this.showPlaceCategoryModal = true;
      this.newPlaceCategory = true;
    },
    openPlaceCategoryModal(category) {
      this.showPlaceCategoryModal = true;
      this.newPlaceCategory = false;
      EventBus.$emit("editModal", category);
    },
    newLink() {
      this.showLinkModal = true;
      this.newLinkModal = true;
    },
    openLinkModal(category) {
      this.showLinkModal = true;
      this.newLinkModal = false;
      EventBus.$emit("editModal", category);
    },
    newEventCategoryModal() {
      this.showEventCategoryModal = true;
      this.newEventCategory = true;
    },
    openEventCategoryModal(category) {
      this.showEventCategoryModal = true;
      this.newEventCategory = false;
      EventBus.$emit("editModal", category);
    },
    newEmergencyNumber() {
      this.showEmergencyNumberModal = true;
      this.newEmergencyNumberModal = true;
    },
    openEmergencyNumberModal(category) {
      this.showEmergencyNumberModal = true;
      this.newEmergencyNumberModal = false;
      EventBus.$emit("editModal", category);
    },
    updatePlaceCategory(category) {
      this.axios
        .delete(
          "apidev/api/places/categories/" + category.id,
          // {
          //   name: category.nombre_categoria,
          //   enabled: !category.enabled
          // },
          this.config
        )
        .then((response) => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Configuración",
              action: "Eliminación de una categoría de lugares de interés",
              observation: category.nombre_categoria,
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          //category.enabled = !category.enabled;
          this.showingConfirmPlaces = false;
          this.showingSuccessDelete = true;
          this.fetchPlaceCategories();
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    updateEventCategory(category) {
      this.axios
        .delete(
          "apidev/api/config/categories/events/" + category.id,
          // {
          //   name: category.name,
          //   enabled: !category.enabled,
          //   icon: category.icon
          // },
          this.config
        )
        .then((response) => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Configuración",
              action: "Eliminación de una categoría de eventos",
              observation: category.name,
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          //category.enabled = !category.enabled;
          this.showingConfirmEvents = false;
          this.showingSuccessDelete = true;
          this.fetchEventCategories();
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchLinks() {
      this.axios
        .get("apidev/api/links", this.config)
        .then((response) => {
          this.externalLinks = response.data.links;
        });
    },
    updateLinks(category) {
      this.axios
        .delete("apidev/api/links/" + category.id, this.config)
        .then((response) => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Configuración",
              action: "Eliminación de una categoría de enlaces externos",
              observation: category.name,
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          this.showingConfirmLinks = false;
          this.showingSuccessDelete = true;
          this.fetchLinks();
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    fetchEmergencyNumbers() {
      this.axios
        .get("apidev/api/emergencynumbers/getnumbers", this.config)
        .then((response) => {
          this.emergencyNumbers = response.data.numbers;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateEmergencyNumbers(category) {
      this.axios
        .delete("apidev/api/emergencynumbers/deletenumber/" + category.id, this.config)
        .then((response) => {
          return this.axios.post(
            "apidev/api/binnacles/monitor/save/",
            {
              module: "Configuración",
              action: "Eliminación de un número de emergencia",
              observation: category.name,
              email: localStorage.getItem("email"),
            },
            this.config
          );
        })
        .then((response) => {
          this.showingConfirmEmergencyNumbers = false;
          this.showingSuccessDelete = true;
          this.fetchEmergencyNumbers();
        })
        .catch((error) => {
          console.error(error.response);
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
  },
  computed: {
    filteredEvents() {
      return this.configs.filter((config) => {
        return config.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  filters: {
    sliceString: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.length > 30 ? value.slice(0, 30) + "..." : value;
    },
  },
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>